

























































import CancelButton from '@/components/buttons/CancelButton.vue'
import SubmitButton from '@/components/buttons/SubmitButton.vue'
import CardTitle from '@/components/CardTitle.vue'
import TenderService from '@/services/tender'
import { CommissionerDTO } from '@/services/tender/types'
import UserService from '@/services/user'
import { errorMessages } from '@/utils/helpers'
import { AxiosError } from 'axios'
import Vue from 'vue'

type CommissionerData = {
  id: number
  name: string
}

export default Vue.extend({
  name: 'ChooseCommissionersButton',
  components: { CardTitle, SubmitButton, CancelButton },
  model: { prop: 'showModal' },
  props: {
    procurementId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data: () => ({
    dialog: false,
    clientId: 0,
    commissioners: [] as CommissionerData[],
    commissionersIds: [] as number[],
  }),
  watch: {
    dialog: function (value) {
      if (value) {
        if (this.procurementId === 0) {
          this.$toast.error(this.$t('somethingWentWrong') as string)
        } else {
          this.fetchCommissioners()
          this.fetchTenderData()
        }
      }
    },
  },
  methods: {
    async assignCommissioners(): Promise<void> {
      const loader = this.$loading.show()
      try {
        const response = await TenderService.assignCommissioners(this.procurementId, this.commissionersIds)
        if (response) {
          this.$emit('updated')
          this.$toast.success(response.data.message)
          loader.hide()
          this.dialog = false
        }
      } catch (err: unknown) {
        const axiosError = err as AxiosError
        if (axiosError?.response?.data) {
          this.$toast.error(errorMessages(axiosError.response.data.message))
          return
        }
        this.$toast.error(this.$t('somethingWentWrong') as string)
      } finally {
        loader.hide()
      }
    },
    async fetchCommissioners(): Promise<void> {
      const response = await UserService.fetchCommissioners()
      if (response?.data) {
        this.commissioners = response.data.data || []
      } else {
        this.commissioners = []
        this.$toast.error(this.$t('could not fetch commissioners') as string)
      }
    },
    async fetchTenderData(): Promise<void> {
      const response = await TenderService.find(this.procurementId)
      const fetchedIds = response?.data?.data?.procurement?.commissioners || []
      this.commissionersIds = fetchedIds.map((comm: CommissionerDTO) => comm.commissionerId)
    },
    toggleCommissioner(id: number): void {
      const index = this.commissionersIds.indexOf(id)
      if (index === -1) {
        this.commissionersIds.push(id)
      } else {
        this.commissionersIds.splice(index, 1)
      }
    },
    isCommissionerSelected(id: number): boolean {
      console.log(this.commissionersIds, id)
      return this.commissionersIds.includes(id)
    },
  },
})
